import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ClientAccount, Maybe, Member } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = Maybe<Array<Member>>;
type TDataPayload = Pick<ClientAccount, 'members'>;

export const useMembers = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query clientAccount {
      clientAccount {
        members {
          email
          id
          lastSignInAt
          translationRequestCount
          role
          name
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useMembers'],
    queryFn: async () =>
      (
        await client.request<unknown, TDataPayload>({
          data: {
            gql: graphql
          }
        })
      ).members
  });
};
